import { defineStore } from 'pinia'

type PlayerStates = Record<string, boolean>

/**
 * Audio player state. Some actions touch the DOM directly (`document.getElementById`).
 */
export const useAudioPlayerStore = defineStore('audio-player', {
  state: () => ({
    // TODO: Change PlayerStates to single Playerstate and check for currentAudioId
    playerStates: {} as PlayerStates,
    currentAudioId: null as string | null,
  }),
  actions: {
    SET_PLAYER_STATE({ id, playerState }: { id: string; playerState: boolean }) {
      this.playerStates = {
        ...this.playerStates,
        [id]: playerState,
      }
    },
    SET_CURRENT_AUDIO_ID(id: string | null) {
      this.currentAudioId = id
    },
    playAudio({ id, rewind = false }: { id: string; rewind?: boolean }) {
      const player = document.getElementById(id) as HTMLAudioElement | null
      this.SET_PLAYER_STATE({ id, playerState: true })
      this.SET_CURRENT_AUDIO_ID(id)
      if (player) {
        if (rewind) player.currentTime = 0
        player.play()

        player.addEventListener('ended', () => {
          this.pauseAudio({ id })
        })
        this.SET_PLAYER_STATE({ id, playerState: true })
        this.SET_CURRENT_AUDIO_ID(id)
      }
    },
    pauseAudio({ id, rewind = false }: { id: string; rewind?: boolean }) {
      const player = document.getElementById(id) as HTMLAudioElement | null
      this.SET_PLAYER_STATE({ id, playerState: false })
      if (player) {
        player.pause()
        if (rewind) player.currentTime = 0
      }
    },
    toggleAudio(id: string) {
      if (this.playerStates[id]) {
        this.pauseAudio({ id })
      } else {
        if (this.currentAudioId && this.currentAudioId !== id) {
          this.pauseAudio({ id: this.currentAudioId, rewind: true })
        }
        this.playAudio({ id })
      }
    },
  },
})
